import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import Link from '../../Link/Link';
import CustomPagination from '../../CustomPagination/CustomPagination';

import messages from '../../../locale/messages';
import { deleteContentPageDetails, updateContentPageStatus } from '../../../actions/siteadmin/ContentPageAction';
import getCurrentPage from '../../../helpers/getCurrentPage';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './ContentPageManagement.css';
import Loader from '../../Common/Loader/Loader';

const ContentPageList = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeId, setActiveId] = useState(null);
  const loading = useSelector((state) => state?.loader?.updateContentStatusLoading)

  const {
    data = [],
    deleteContentPageDetails,
    updateContentPageStatus,
    intl: { formatMessage },
    refetch
  } = props;

  const paginationData = (page) => {
    setCurrentPage(page);
    refetch({ currentPage: page });
  };

  const handleDelete = async (id, page) => {
    const newPage = await getCurrentPage({ results: data?.results, page });
    const response = await deleteContentPageDetails(id, newPage);
    if (response?.status === 200) {
      setCurrentPage(newPage);
      refetch({ currentPage: newPage });
    }
  };

  return (
    <div>
      <div className={cx(s.displayInlineBlock, s.btnSection, 'textAlignLeftRTL')}>
        <Link to={'/siteadmin/contentpage/add'} className={cx(bt.btnPrimary, bt.displayInlineBlock)}>
          <FormattedMessage {...messages.addPage} />
        </Link>
      </div>
      <div className={cx('tableOuterContainer', bt.spaceTop4)}>
        <Table className="tableContainer">
          <thead>
            <tr>
              <th scope="col"><FormattedMessage {...messages.id} /></th>
              <th scope="col"><FormattedMessage {...messages.metaTitle} /></th>
              <th scope="col"><FormattedMessage {...messages.metaDescriptionText} /></th>
              <th scope="col"><FormattedMessage {...messages.pageTitle} /></th>
              <th scope="col"><FormattedMessage {...messages.pageUrl} /></th>
              <th scope="col"><FormattedMessage {...messages.status} /></th>
              <th scope="col"><FormattedMessage {...messages.preview} /></th>
              <th scope="col"><FormattedMessage {...messages.action} /></th>
              <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
            </tr>
          </thead>
          <tbody>
            {data?.results?.length > 0 ? (
              data.results.map((item, index) => (
                <tr key={index}>
                  <td data-label={formatMessage(messages.id)}>{item?.id}</td>
                  <td data-label={formatMessage(messages.metaTitle)}>{item?.metaTitle}</td>
                  <td data-label={formatMessage(messages.metaDescriptionText)}>{item?.metaDescription}</td>
                  <td data-label={formatMessage(messages.pageTitle)}>{item?.pageTitle}</td>
                  <td data-label={formatMessage(messages.pageUrl)}>{item?.pageUrl}</td>
                  <td data-label={formatMessage(messages.status)}>
                    <div>
                      {
                        activeId === item.id && loading
                          ? <Loader type='text' />
                          :
                          <Link noLink
                            onClick={() => {
                              setActiveId(item.id);
                              updateContentPageStatus(item.id, item.isEnable, currentPage, refetch, () => setActiveId(null));
                            }}
                            className={s.noLink}>
                            {formatMessage(messages[item.isEnable == 1 ? 'Disable' : 'Enable'])}
                          </Link>

                      }

                    </div>

                  </td>
                  <td data-label={formatMessage(messages.preview)}>
                    <div>
                      <a href={'/' + item.pageUrl} target="_blank" rel="noopener noreferrer" className='actionLinkText'>
                        <FormattedMessage {...messages.preview} />
                      </a>
                    </div>
                  </td>
                  <td data-label={formatMessage(messages.action)}>
                    <div>
                      <Link to={'/siteadmin/contentpage/edit/' + item.id} className={s.noLink}>
                        <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                        <span className={cx(s.vtrMiddle)}>
                          <FormattedMessage {...messages.editAction} />
                        </span>
                      </Link>
                    </div>
                  </td>
                  <td data-label={formatMessage(messages.deleteAction)}>
                    <div>
                      <Button className={s.iconBtn} onClick={() => handleDelete(item.id, currentPage)}>
                        <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                        <span className={s.vtrMiddle}>
                          <FormattedMessage {...messages.deleteAction} />
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className={'tableNoRecordCel'}>
                  <FormattedMessage {...messages.noResult} />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {data?.results?.length > 0 && (
        <div className={cx(bt.space5, bt.spaceTop5)}>
          <CustomPagination
            total={data?.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={paginationData}
            paginationLabel={formatMessage(messages.paginationrecords)}
          />
        </div>
      )}
    </div>
  );
};

ContentPageList.propTypes = {
  data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      metaTitle: PropTypes.string,
      metaDescription: PropTypes.string,
      pageUrl: PropTypes.string,
      content: PropTypes.string,
    })),
    count: PropTypes.number,
  }),
  refetch: PropTypes.func.isRequired,
  deleteContentPageDetails: PropTypes.func.isRequired,
  updateContentPageStatus: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

ContentPageList.defaultProps = {
  data: { results: [], count: 0 },
};

const mapState = (state) => ({});

const mapDispatch = {
  deleteContentPageDetails,
  updateContentPageStatus
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(ContentPageList)));